import React, { useState, useEffect } from "react";
import SavedReports from "./SavedReports";
import FAQ from "./FAQ";
import PlanOverview from "./PlanOverview";
import ContactForm from "./ContactForm";
import axiosClient from "../../axios-client";
import { useNavigate } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUpRightFromSquare } from "@fortawesome/free-solid-svg-icons"; // Import the icon

const keywords = ["Industry Reports", "Market Insights", "Consumer Data"];

function Profile() {
  const [searchQuery, setSearchQuery] = useState("");
  const [userDetails, setUserDetails] = useState(null); // Initialize with null
  const [error, setError] = useState(null);
  const [user, setUser] = useState(null); // Assuming you have a way to get the logged-in user
  const [subscriptions, setSubscriptions] = useState([]);
  const [searchResults, setSearchResults] = useState([]);

  const userID = localStorage.getItem("userID");
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  // Fetch user details when the component mounts
  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          setError("No token found in local storage");
          return;
        }

        const response = await axiosClient.get("/users/profile");
        console.log("Response data:", response.data); // Log response data
        if (response.data && response.data.user) {
          setUser(response.data);
          setUserDetails(response.data);
          console.log(userDetails);
          localStorage.setItem("User Name", response.data.user.name);
        } else {
          throw new Error(
            "User data is missing or has an unexpected structure"
          );
        }
      } catch (error) {
        console.error("Error fetching user details:", error.message || error); // Log error message
        setError(
          error.message || "An error occurred while fetching user details"
        );
      }
    };

    fetchUserDetails();
  }, []);
  console.log(user);

  useEffect(() => {
    if (token) {
      const fetchSubscriptions = async () => {
        try {
          const response = await axiosClient.get(
            `/subscriptions/getSubscriptionsByUser/${userID}`
          );

          setSubscriptions(response.data);
          console.log("Subscriptions:", response.data);
          const reportDownload = response.data[0].plan.features.reportDownloads;
          if (
            response.data.length > 0 &&
            response.data[0].status === "Active"
          ) {
            localStorage.setItem("userStatus", "Active");
            localStorage.setItem("User Plan", response.data[0].plan.name);
            localStorage.setItem("downloadReport", reportDownload);
          }
        } catch (error) {
          console.error("Error fetching subscriptions:", error);
        }
      };
      fetchSubscriptions();
    }
  }, [token, userID]);

  const handleSearch = async (query) => {
    if (query.trim()) {
      try {
        const response = await axiosClient.get(
          `/reports/search-by-title/?title=${query}`
        );
        const searchResults = response.data;
        setSearchResults(searchResults);
        console.log("Search results:", searchResults);
        // Handle the search results as needed
      } catch (error) {
        console.error("Error fetching search results:", error);
      }
    }
  };
  const handleResultClick = (report) => {
    navigate(`/report`, { state: report });
  };
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchQuery.trim()) {
        handleSearch(searchQuery);
      } else {
        // Clear the search results if the query is empty
        setSearchResults([]);
      }
    }, 300); // Adjust the debounce delay as needed

    return () => clearTimeout(delayDebounceFn);
  }, [searchQuery]);
  return (
    <>
      <div className="pt-8 md:pt-16 pb-6 md:pb-10 px-4 text-center">
        <div className="text-2xl sm:text-3xl md:text-4xl xl:text-5xl font-semibold font4 font-urban mb-4">
          <h1 className="max-w-4xl mx-auto pb-2">
            Welcome back,{" "}
            {userDetails && userDetails.user && userDetails.user.name
              ? userDetails.user.name
              : "User"}
            !
          </h1>
        </div>
        {error && <p className="text-red-500">{error}</p>}{" "}
        {/* Display error if any */}
        <p className="text-base sm:text-lg mb-6 md:mb-8 max-w-4xl mx-auto font-urban px-4">
          Access in-depth market insights with ease. Search, filter, and
          download reports across industries, regions, and segments all through
          an intuitive platform designed for informed decision-making.
        </p>
        <div className="relative max-w-4xl mx-auto mb-4 px-4">
          <input
            type="text"
            placeholder="Search for any services"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full border border-gray-300 p-3 rounded-md font-euclid shadow-sm pr-12"
          />
          <button
            onClick={() => handleSearch(searchQuery)}
            className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-pink text-white px-4 h-[calc(100%-2px)] rounded-r-md flex items-center justify-center"
          >
            <img src="images/search.png" alt="search" className="w-5 h-5" />
          </button>
        </div>
        {/* Display search results */}
        {searchResults.length > 0 && (
          <div className="max-w-4xl mx-auto mt-4 px-4">
            <ul className="bg-white border border-gray-300 rounded-md shadow-sm">
              {searchResults.map((result, index) => (
                <li
                  key={index}
                  className="px-4 py-2 text-left border-b border-gray-200 flex justify-between items-center"
                >
                  {result.reportTitle}
                  <button
                    className="text-blue-500 hover:text-blue-700"
                    onClick={() => handleResultClick(result)}
                  >
                    <FontAwesomeIcon icon={faUpRightFromSquare} />
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
        {/* <div className="max-w-4xl mx-auto font-urban flex flex-wrap items-center gap-2 md:gap-3 px-4">
          <span className="text-gray-600">Keywords:</span>
          {keywords.map((keyword, index) => (
            <div
              key={index}
              className="text-sm px-3 md:px-4 py-1 border border-gray-300 rounded-full text-gray-700 bg-white hover:bg-gray-100 cursor-pointer"
            >
              {keyword}
            </div>
          ))}
        </div> */}
      </div>
      <SavedReports />
      <PlanOverview />
      <FAQ />
      <ContactForm />
    </>
  );
}

export default Profile;
